import { Inject, Injectable } from '@angular/core';
import { Client, Contact, Folder } from '@lockton-apps/shared/interfaces';
import { find } from 'lodash';
import {
  MOCKED_CLIENT_CONTACTS,
  MOCKED_CLIENT_FOLDERS,
  MOCKED_CLIENTS,
} from '../index';

@Injectable()
export class MocksService {
  constructor(
    @Inject(MOCKED_CLIENTS) private readonly clients: Client[],
    @Inject(MOCKED_CLIENT_FOLDERS)
    private readonly clientFolders: Record<number, Folder[]>,
    @Inject(MOCKED_CLIENT_CONTACTS)
    private readonly clientContacts: Record<number, Contact[]>
  ) {}

  getClient(id: number): Client {
    const client = find(this.clients, { id });

    if (!client) {
      throw new Error(`No mocked client id "${id}"`);
    }

    return client;
  }

  getClientFolders(id: number): Folder[] {
    const clientFolders = this.clientFolders[id];

    if (!clientFolders) {
      throw new Error(`No mocked folders for client id "${id}"`);
    }

    return clientFolders;
  }

  getClientContacts(id: number): Contact[] {
    const clientContacts = this.clientContacts[id];

    if (!clientContacts) {
      throw new Error(`No mocked contacts for client id "${id}"`);
    }

    return clientContacts;
  }
}
